const populateRecoPlaceholders = (selector, noks) => {
    const blocks = $(selector);

    const promises = [];
    for (let block of blocks) {
        let recoId = $(block).data('reco-id') || '',
            recoTitle = $(block).data('reco-title') || '',
            colHandle = $(block).data('col-handle') || '';
        const newPromise = new Promise((resolve, reject) => {
            fetch('/?view=recommendation&id=' + recoId + '&title=' + recoTitle + '&col=' + colHandle + '&noks=' + noks)
                .then(response => response.text())
                .then(html => {
                    resolve(html);
                });
        });
        
        promises.push(newPromise);
    }

    Promise.all(promises)
        .then(responses => {
                for (let i=0; i < blocks.length; i++) {
                    $(blocks[i]).append(responses[i]);
                }
            }
        );
}